module.exports = __webpack_public_path__ + "static/media/fr_form.dc0b87fe.jpg";